type MockFinalDeliveryVendor = {
  scac: string;
  display: string;
};

export const MOCK_FINAL_DELIVERY_VENDORS: readonly MockFinalDeliveryVendor[] = [
  { scac: "NMTF", display: "NMTF Transport" },
  { scac: "SAIA", display: "Saia Motor Freight" },
  { scac: "XPOL", display: "XPO Logistics" },
  { scac: "EXLA", display: "Estes Express Lines" },
  { scac: "FXFE", display: "FedEx Freight" },
  { scac: "WARD", display: "Ward Trucking" },
];

export const MOCK_CROSSDOCK_SERVICE_LEVEL_OPTIONS = [
  "AIR",
  "LTL",
  "LTL-CC",
  "LTL-UC",
  "MXUS-LTL",
  "NON-NTM",
  "OCEAN",
  "OCEAN-PT",
  "PARTNER",
  "PARTNERL",
  "POOL",
  "TRUCKLOAD",
  "VOLUME",
] as const;

/** MSW: GET /eol/criteria/:id — View Criteria dialog (crossdock / shared EOL criteria shape). */
export const mockEolCriteriaDetailsApiResponse = {
  success: true,
  message: "Retrieved criteria details for criteria_id: 72",
  errorCode: null,
  item: {
    criteria: {
      groups: [
        {
          sequences: [
            {
              startTableName: "CLIENT",
              endTableName: "ACCESSORIAL",
              startFieldName: "ADDRESS",
              endFieldName: "ACCESSORIAL_CODE",
              startLookup: "COUNTRY",
              endLookup: "ACCESSORIAL_CODE",
              startLogic: "between",
              endLogic: "!=",
              logicValue: "like",
              startMin: "CA, OR, WA",
              startMax: "CA, OR, WA",
              endMin: "CA, OR, WA",
              endMax: "CA, OR, WA",
              reverseRange: false,
            },
          ],
        },
      ],
      betweenGroupLogic: [],
    },
  },
};
